export const AimsAvailabilityApiResponse = {
  result: "AimsAvailable",
  message: "low_risk",
  hasPandC: false,
  warningFromZoom: null,
  warningFromOutlook: null,
  hasExternalUser: false,
  summaryButtonFor: "mznwng@amazon.com",
  alias: "mznwng",
  meetingUuid: "TUHHpXOIQRe5wt5XANnFjA=="
};

export const sampleSummaryList = [
  {
    "meetingTitle": "[Normal meeting] Lu Test",
    "role":"host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "originalSummary": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information. The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.\n\nDecisions:\n- Announce the support of Bedrock agents for managing complex workflows.\n- Implement a supervisor agent to coordinate and manage interactions between specialized agents.\n\n\nNext Steps:\n- Develop the Bedrock agent framework.\n- Test the multi-agent collaboration system with Moody's for financial risk alerts.\n- Create documentation and guidelines for using Bedrock agents in complex workflows.\n",
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information.",
    "narrativeSummary": "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.",
    "decisions": [
      "Announce the support of Bedrock agents for managing complex workflows.",
      "Implement a supervisor agent to coordinate and manage interactions between specialized agents."
    ],
    "nextSteps": [
      "Develop the Bedrock agent framework.",
      "Test the multi-agent collaboration system with Moody's for financial risk alerts.",
      "Create documentation and guidelines for using Bedrock agents in complex workflows."
    ],
    "summaryType": "low_risk",
    "attendeeNameList": "Adrian David,Feng Shan,Lu Wang,Tianlei Xu,Tong Zhang,TestLastName verylongname-verylongname,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "00001"
  },
  {
    "meetingTitle": "[server_error] Lu Test",
    "summaryType": "server_error",
    "role":"host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "originalSummary": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information. The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.\n\nDecisions:\n- Announce the support of Bedrock agents for managing complex workflows.\n- Implement a supervisor agent to coordinate and manage interactions between specialized agents.\n\n\nNext Steps:\n- Develop the Bedrock agent framework.\n- Test the multi-agent collaboration system with Moody's for financial risk alerts.\n- Create documentation and guidelines for using Bedrock agents in complex workflows.\n",
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information.",
    "narrativeSummary": "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.",
    "decisions": [
      "Announce the support of Bedrock agents for managing complex workflows.",
      "Implement a supervisor agent to coordinate and manage interactions between specialized agents."
    ],
    "nextSteps": [
      "Develop the Bedrock agent framework.",
      "Test the multi-agent collaboration system with Moody's for financial risk alerts.",
      "Create documentation and guidelines for using Bedrock agents in complex workflows."
    ],
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "00001"
  },
  {
    "meetingTitle": "P&C Lu is host",
    "role":"host",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "originalSummary": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information. The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.\n\nDecisions:\n- Announce the support of Bedrock agents for managing complex workflows.\n- Implement a supervisor agent to coordinate and manage interactions between specialized agents.\n\n\nNext Steps:\n- Develop the Bedrock agent framework.\n- Test the multi-agent collaboration system with Moody's for financial risk alerts.\n- Create documentation and guidelines for using Bedrock agents in complex workflows.\n",
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information.",
    "narrativeSummary": "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.",
    "decisions": [
      "Announce the support of Bedrock agents for managing complex workflows.",
      "Implement a supervisor agent to coordinate and manage interactions between specialized agents."
    ],
    "nextSteps": [
      "Develop the Bedrock agent framework.",
      "Test the multi-agent collaboration system with Moody's for financial risk alerts.",
      "Create documentation and guidelines for using Bedrock agents in complex workflows."
    ],
    "summaryType": "privileged_and_confidential",
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "2ce530b329b6493fac742c88cea7aa7b"
  },
  {
    "meetingTitle": "P&C Lu is attendee",
    "role":"attendee",
    "meetingStartTime": 1748984400,
    "meetingEndTime": 1748986200,
    "originalSummary": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information. The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.\n\nDecisions:\n- Announce the support of Bedrock agents for managing complex workflows.\n- Implement a supervisor agent to coordinate and manage interactions between specialized agents.\n\n\nNext Steps:\n- Develop the Bedrock agent framework.\n- Test the multi-agent collaboration system with Moody's for financial risk alerts.\n- Create documentation and guidelines for using Bedrock agents in complex workflows.\n",
    "conciseOverview": "The meeting discussed the introduction of Bedrock agents to support complex workflows involving multiple agents working in parallel and sharing information.",
    "narrativeSummary": "The team addressed customer feedback regarding the complexity of managing multiple agents across various tasks. They introduced the concept of Bedrock agents, which include a supervisor agent to manage and coordinate specialized agents. An example involving Moody's use of this technology for financial risk analysis was presented to illustrate the benefits.",
    "decisions": [
      "Announce the support of Bedrock agents for managing complex workflows.",
      "Implement a supervisor agent to coordinate and manage interactions between specialized agents."
    ],
    "nextSteps": [
      "Develop the Bedrock agent framework.",
      "Test the multi-agent collaboration system with Moody's for financial risk alerts.",
      "Create documentation and guidelines for using Bedrock agents in complex workflows."
    ],
    "summaryType": "privileged_and_confidential",
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Tue, June 3 | 02:00 PM - 02:30 PM PDT",
    "meetingUuid": "ttoXAEsJRpCpe9+bRgUCig==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "2ce530b329b6493fac742c88cea7aa7b"
  },
  {
    "meetingTitle": "[Short Meeting]Lu Wang (mznwng)'s Personal Meeting Room",
    "summaryType": "short_meeting",
    "meetingStartTime": 1748461584,
    "meetingEndTime": 1748461797,
    "originalSummary": "The company discussed the success and impact of their custom silicon development, particularly with the Graviton processor, and its benefits for AWS customers. The meeting reviewed the journey and success of developing custom silicon, highlighted by the Graviton processor. It discussed the initial skepticism, the launch and rapid adoption of Graviton, and its significant benefits in terms of price performance and energy efficiency. The latest Graviton 4 chip was introduced, showcasing its enhanced capabilities and broader workload applications.\n\nDecisions:\n- Continue the development and enhancement of custom silicon solutions like Graviton.\n- Expand the use of Graviton processors across more AWS services and customer workloads.\n\n\nNext Steps:\n- Promote the adoption of Graviton 4 among existing and new AWS customers.\n- Gather feedback from customers using Graviton 4 to further refine and improve the processor.\n- Explore additional applications and workloads that can benefit from Graviton technology.\n",
    "conciseOverview": "The company discussed the success and impact of their custom silicon development, particularly with the Graviton processor, and its benefits for AWS customers.",
    "narrativeSummary": "The meeting reviewed the journey and success of developing custom silicon, highlighted by the Graviton processor. It discussed the initial skepticism, the launch and rapid adoption of Graviton, and its significant benefits in terms of price performance and energy efficiency. The latest Graviton 4 chip was introduced, showcasing its enhanced capabilities and broader workload applications.",
    "decisions": [
      "Continue the development and enhancement of custom silicon solutions like Graviton.",
      "Expand the use of Graviton processors across more AWS services and customer workloads."
    ],
    "nextSteps": [
      "Promote the adoption of Graviton 4 among existing and new AWS customers.",
      "Gather feedback from customers using Graviton 4 to further refine and improve the processor.",
      "Explore additional applications and workloads that can benefit from Graviton technology."
    ],
    "attendeeNameList": "Lu Wang,",
    "timeZone": "PST",
    "meetingDateAndTime": "Wed, May 28 | 12:46 PM - 12:49 PM PDT",
    "meetingUuid": "8GaQ3Pw7RESvYwtjeMcgOg==",
    "feedback": null,
    "feedbackReason": null,
    "feedbackComment": null,
    "feedbackTimestamp": null,
    "aimsUuid": "20841bb9221644eeab1688a7bdf88f83"
  },
  {
    meetingTitle: "[investigation]Wang, Lu's Personal Meeting Room",
    summaryType: "investigation",
    aimsUuid: "111",
    alias: "mznwng",
    aiClassification: "mentorship;project_status",
    allowSummaryShared: true,
    attendeeNameList: "Lu Wang,",
    conciseOverview:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    decisions: [
      "Announced the launch of P6 family of instances powered by new Nvidia chips.",
      "Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.",
    ],
    informedMethod: "Email",
    informedTimestamp: 1748462396,
    meetingUniqueId: "c6k1uudySWOcX8HfQ2h0Ag==",
    narrativeSummary:
      "The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.",
    nextSteps: [
      "Prepare for the release of P6 instances early next year.",
      "Continue beta testing and refining Trainium 2 chips based on customer feedback.",
      "Promote the cost savings and performance benefits of new instances and chips to potential customers.",
    ],
    originalSummary:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments. The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.\n\nDecisions:\n- Announced the launch of P6 family of instances powered by new Nvidia chips.\n- Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.\n\n\nNext Steps:\n- Prepare for the release of P6 instances early next year.\n- Continue beta testing and refining Trainium 2 chips based on customer feedback.\n- Promote the cost savings and performance benefits of new instances and chips to potential customers.\n",
    role: "host",
    rtmsEndTime: 1748462391,
    rtmsStartTime: 1748291782,
    summaryHighlight:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    userEmail: "mznwng@amazon.com",
    userTimezone: "PST",
    zoomMeetingId: "5567153788",
    zoomMeetingType: 4,
    meetingStartTime: 1748291782,
    meetingEndTime: 1748462391,
    meetingDateAndTime: "Sun, May 26 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
  {
    aimsUuid: "222",
    role: "host",
    alias: "mznwng",
    aiClassification: "mentorship;project_status",
    allowSummaryShared: true,
    attendeeNameList: "Lu Wang,",
    conciseOverview:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    decisions: [
      "Announced the launch of P6 family of instances powered by new Nvidia chips.",
      "Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.",
    ],
    informedMethod: "Email",
    informedTimestamp: 1748462396,
    meetingUniqueId: "c6k1uudySWOcX8HfQ2h0Ag==",
    narrativeSummary:
      "The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.",
    nextSteps: [
      "Prepare for the release of P6 instances early next year.",
      "Continue beta testing and refining Trainium 2 chips based on customer feedback.",
      "Promote the cost savings and performance benefits of new instances and chips to potential customers.",
    ],
    originalSummary:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments. The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.\n\nDecisions:\n- Announced the launch of P6 family of instances powered by new Nvidia chips.\n- Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.\n\n\nNext Steps:\n- Prepare for the release of P6 instances early next year.\n- Continue beta testing and refining Trainium 2 chips based on customer feedback.\n- Promote the cost savings and performance benefits of new instances and chips to potential customers.\n",
    rtmsEndTime: 1748462391,
    rtmsStartTime: 1748118982,
    summaryHighlight:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    summaryType: "low_risk",
    userEmail: "mznwng@amazon.com",
    userTimezone: "PST",
    zoomMeetingId: "5567153788",
    zoomMeetingType: 4,
    meetingTitle: "[Test2]Wang, Lu's Personal Meeting Room",
    meetingStartTime: 1748118982,
    meetingEndTime: 1748462391,
    meetingDateAndTime: "Tue, May 24 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
  {
    meetingTitle: "[hr_complaint]Test meeting",
    summaryType: "hr_complaint",
    role: "host",
    aimsUuid: "333",
    alias: "mznwng",
    aiClassification: "mentorship;project_status",
    allowSummaryShared: true,
    attendeeNameList: "Lu Wang,",
    conciseOverview:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    decisions: [
      "Announced the launch of P6 family of instances powered by new Nvidia chips.",
      "Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.",
    ],
    informedMethod: "Email",
    informedTimestamp: 1748462396,
    meetingUniqueId: "c6k1uudySWOcX8HfQ2h0Ag==",
    narrativeSummary:
      "The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.",
    nextSteps: [
      "Prepare for the release of P6 instances early next year.",
      "Continue beta testing and refining Trainium 2 chips based on customer feedback.",
      "Promote the cost savings and performance benefits of new instances and chips to potential customers.",
    ],
    originalSummary:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments. The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.\n\nDecisions:\n- Announced the launch of P6 family of instances powered by new Nvidia chips.\n- Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.\n\n\nNext Steps:\n- Prepare for the release of P6 instances early next year.\n- Continue beta testing and refining Trainium 2 chips based on customer feedback.\n- Promote the cost savings and performance benefits of new instances and chips to potential customers.\n",
    rtmsEndTime: 1748462391,
    rtmsStartTime: 1748462048,
    summaryHighlight:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    userEmail: "mznwng@amazon.com",
    userTimezone: "PST",
    zoomMeetingId: "5567153788",
    zoomMeetingType: 4,
    meetingStartTime: 1748462048,
    meetingEndTime: 1748462391,
    meetingDateAndTime: "Mon, May 27 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
  {
    meetingTitle: "[performance_review] Test 4",
    summaryType: "performance_review",
    aimsUuid: "444",
    alias: "mznwng",
    aiClassification: "mentorship;project_status",
    allowSummaryShared: true,
    attendeeNameList: "Lu Wang,",
    conciseOverview:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    decisions: [
      "Announced the launch of P6 family of instances powered by new Nvidia chips.",
      "Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.",
    ],
    informedMethod: "Email",
    informedTimestamp: 1748462396,
    meetingUniqueId: "c6k1uudySWOcX8HfQ2h0Ag==",
    narrativeSummary:
      "The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.",
    nextSteps: [
      "Prepare for the release of P6 instances early next year.",
      "Continue beta testing and refining Trainium 2 chips based on customer feedback.",
      "Promote the cost savings and performance benefits of new instances and chips to potential customers.",
    ],
    originalSummary:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments. The meeting focused on AWS's strategies to enhance its AI and generative AI offerings. It highlighted the collaboration with Nvidia, the launch of new P6 instances, and the introduction of AWS's in-house Trainium 2 chips. These advancements aim to provide faster compute capabilities and more cost-effective solutions for AI workloads.\n\nDecisions:\n- Announced the launch of P6 family of instances powered by new Nvidia chips.\n- Introduced Trainium 2, AWS's in-house AI chip, offering 30-40% better performance.\n\n\nNext Steps:\n- Prepare for the release of P6 instances early next year.\n- Continue beta testing and refining Trainium 2 chips based on customer feedback.\n- Promote the cost savings and performance benefits of new instances and chips to potential customers.\n",
    role: "host",
    rtmsEndTime: 1748462391,
    rtmsStartTime: 1748462048,
    summaryHighlight:
      "The meeting discussed advancements in AWS's AI and generative AI capabilities, including new instance launches and in-house AI chip developments.",
    userEmail: "mznwng@amazon.com",
    userTimezone: "PST",
    zoomMeetingId: "5567153788",
    zoomMeetingType: 4,
    meetingStartTime: 1748462048,
    meetingEndTime: 1748462391,
    meetingDateAndTime: "Mon, May 27 | 09:54 AM - 10:00 AM PDT",
    meetingUuid: "someGeneratedUuidHere==",
    feedback: null,
    feedbackReason: null,
    feedbackComment: null,
    feedbackTimestamp: null,
  },
];
